import React, { useState, useEffect } from 'react';
import API_BASE from '../config';

function CateringOverview({ accessCode }) {
  const [registrations, setRegistrations] = useState([]);
  const [config, setConfig] = useState({ menus: [], relations: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [registrationsRes, configRes] = await Promise.all([
        fetch(`${API_BASE}/registrations`, { headers: { 'x-access-code': accessCode } }),
        fetch(`${API_BASE}/config`)
      ]);
      setRegistrations(await registrationsRes.json());
      setConfig(await configRes.json());
    } catch (err) {
      console.error('Failed to load data:', err);
    }
    setLoading(false);
  };

  if (loading) return <p>Caricamento...</p>;

  const ALL_CLASSES = config.classes || ['1A','1B','1C','2A','2B','2C','3A','3B','3C'];

  // Count menus across all participants
  const menuCounts = {};
  config.menus.forEach(m => {
    menuCounts[m.name] = { count: 0, price: m.price };
  });

  registrations.forEach(reg => {
    reg.participants.forEach(p => {
      if (menuCounts[p.menu]) {
        menuCounts[p.menu].count++;
      } else {
        menuCounts[p.menu] = { count: 1, price: 0 };
      }
    });
  });

  const totalParticipants = Object.values(menuCounts).reduce((sum, m) => sum + m.count, 0);
  const grandTotal = Object.values(menuCounts).reduce((sum, m) => sum + m.count * m.price, 0);

  // Per-class breakdown
  const classBreakdown = ALL_CLASSES.map(cls => {
    const classRegs = registrations.filter(r => r.student.class === cls);
    const counts = {};
    config.menus.forEach(m => { counts[m.name] = 0; });
    classRegs.forEach(reg => {
      reg.participants.forEach(p => {
        if (counts[p.menu] !== undefined) counts[p.menu]++;
      });
    });
    const classTotal = Object.entries(counts).reduce((sum, [name, count]) => {
      const menu = config.menus.find(m => m.name === name);
      return sum + count * (menu ? menu.price : 0);
    }, 0);
    return { class: cls, counts, total: classTotal };
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h2 style={{ margin: 0 }}>Panoramica Catering</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button className="btn-download-sm" onClick={() => window.open(`${API_BASE}/export/catering/excel?code=${accessCode}`, '_blank')}>📊 Excel</button>
          <button className="btn-download-sm" onClick={() => window.open(`${API_BASE}/export/catering/pdf?code=${accessCode}`, '_blank')}>📄 PDF</button>
        </div>
      </div>

      <div className="catering-section">
        <h3>Riepilogo Generale</h3>
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Menù</th>
              <th>Prezzo Unitario</th>
              <th>Quantità</th>
              <th>Subtotale</th>
            </tr>
          </thead>
          <tbody>
            {config.menus.map(menu => (
              <tr key={menu.name}>
                <td>{menu.name}</td>
                <td>€{menu.price}</td>
                <td>{menuCounts[menu.name]?.count || 0}</td>
                <td>€{(menuCounts[menu.name]?.count || 0) * menu.price}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="catering-total-row">
              <td><strong>Totale</strong></td>
              <td></td>
              <td><strong>{totalParticipants}</strong></td>
              <td><strong>€{grandTotal}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="catering-section">
        <h3>Dettaglio per Classe</h3>
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Classe</th>
              {config.menus.map(m => (
                <th key={m.name}>{m.name}</th>
              ))}
              <th>Totale</th>
            </tr>
          </thead>
          <tbody>
            {classBreakdown.map(row => (
              <tr key={row.class}>
                <td><strong>{row.class}</strong></td>
                {config.menus.map(m => (
                  <td key={m.name}>{row.counts[m.name]}</td>
                ))}
                <td><strong>€{row.total}</strong></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="catering-total-row">
              <td><strong>Totale</strong></td>
              {config.menus.map(m => (
                <td key={m.name}><strong>{menuCounts[m.name]?.count || 0}</strong></td>
              ))}
              <td><strong>€{grandTotal}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default CateringOverview;
